import React from "react";
import "./Features.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function Features() {

  useEffect(() => {
    AOS.init({
      duration: 200,
      once: false
    });
    AOS.refresh();
  }, []);

  return (
    <div className="container mt-5 mb-5">
      <div className="row justify-content-center mt-5">
        <div className="col-auto mt-5 text-center">
          <span
            className="text-center fw-bold fs-5 rounded-pill px-4 py-2"
            style={{
              background:
                "linear-gradient(135deg, #fef2f2 0%, #fff1f2 50%, #fce7f3 100%)",
              color: "#FF5656",
            }}
          >
            Features
          </span>
          <h1 className="mt-4">𝑾𝒉𝒚 𝑪𝒉𝒐𝒐𝒔𝒆 𝑳𝒊𝒇𝒆𝑪𝒐𝒏𝒏𝒆𝒄𝒕?</h1>
          <p className="mt-3">
            Powerful features designed to make blood donation simple,
            accessible, and impactful.
          </p>
        </div>
      </div>

      {/* Cards Section */}
      <div className="row mt-5 g-4 align-items-stretch">

        {/* Card 1 */}
        <div data-aos="fade-right" className="col-md-6 col-12">
          <div
            className="card h-100"
            style={{
              width: "100%",
              borderRadius: "20px",
              background:
                "linear-gradient(135deg, #fef2f2 0%, #fff1f2 50%, #fce7f3 100%)",
            }}
          >
            <div className="card-body">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: "red",
                  width: "60px",
                  height: "60px",
                  borderRadius: "15px",
                }}
              >
                <h5 className="mt-2" style={{ color: "white" }}>
                  <i className="fa-solid fa-location-dot fs-3"></i>
                </h5>
              </div>

              <h6 className="mb-3 fw-bold fs-4 mt-3">
                Location-Based Search
              </h6>
              <p>
                Find donors or recipients in your area instantly with our smart
                geolocation system.
              </p>
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div data-aos="fade-left" className="col-md-6 col-12">
          <div
            className="card h-100"
            style={{
              width: "100%",
              borderRadius: "20px",
              backgroundColor: "#fffae6",
            }}
          >
            <div className="card-body">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: "#ffb84d",
                  width: "60px",
                  height: "60px",
                  borderRadius: "15px",
                }}
              >
                <h5 className="mt-2" style={{ color: "white" }}>
                  <i className="fa-regular fa-clock fs-3"></i>
                </h5>
              </div>

              <h6 className="mb-3 fw-bold fs-4 mt-3">
                Real-Time Availability
              </h6>
              <p>
                See donor availability status instantly with live updates and
                smart scheduling.
              </p>
            </div>
          </div>
        </div>

        {/* Card 3 */}
        <div data-aos="fade-right" className="col-md-6 col-12">
          <div
            className="card h-100"
            style={{
              width: "100%",
              borderRadius: "20px",
              backgroundColor: "#e6ffee",
            }}
          >
            <div className="card-body">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: "#47d147",
                  width: "60px",
                  height: "60px",
                  borderRadius: "15px",
                }}
              >
                <h5 className="mt-2" style={{ color: "white" }}>
                  <i className="fa-solid fa-shield-halved fs-3"></i>
                </h5>
              </div>

              <h6 className="mb-3 fw-bold fs-4 mt-3">
                Verified Donors
              </h6>
              <p>
                Every donor is verified through a rigorous process to ensure
                safety and trust.
              </p>
            </div>
          </div>
        </div>

        {/* Card 4 */}
        <div data-aos="fade-left" className="col-md-6 col-12">
          <div
            className="card h-100"
            style={{
              width: "100%",
              borderRadius: "20px",
              backgroundColor: "#f2e6ff",
            }}
          >
            <div className="card-body">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: "#a64dff",
                  width: "60px",
                  height: "60px",
                  borderRadius: "15px",
                }}
              >
                <h5 className="mt-2" style={{ color: "white" }}>
                  <i className="fa-regular fa-bell fs-3"></i>
                </h5>
              </div>

              <h6 className="mb-3 fw-bold fs-4 mt-3">
                Instant Notifications
              </h6>
              <p>
                Get notified immediately when a matching donor is found near
                your location.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Features;